import { PanelResultDetails } from "../../store/slices/order/types";
import { isNumber } from "../../utils/helper";
import ResultScale from "./ResultScale";

const TestResultRanges = ({
  resultDetails,
}: {
  resultDetails: PanelResultDetails;
}) => {
  const displayRanges = () => {
    if (resultDetails?.minValue && resultDetails?.minValue) {
      //check if min and max are numbers
      if (
        isNumber(resultDetails?.minValue) &&
        isNumber(resultDetails.maxValue)
      ) {
        //range images
        return (
          <div className="flex flex-col">
            <ResultScale
              min={parseFloat(resultDetails?.minValue)}
              max={parseFloat(resultDetails?.maxValue as string)}
              value={parseFloat(resultDetails?.strValue)}
            />
            {/* <div className="mb-4"></div> */}

            <p className="text-[0.75rem] font-[500] mt-4">
              Reference Range: Min: {resultDetails?.minValue} - Max:
              {resultDetails?.maxValue}
            </p>
          </div>
        );
      } else {
        return (
          <div className="flex flex-col items-center">
            <p>Min: {resultDetails?.minValue}</p>
            <p>Max: {resultDetails?.maxValue}</p>
          </div>
        );
      }
    }
  };
  return <div className="mt-4">{displayRanges() || "-------------"}</div>;
};

export default TestResultRanges;
